import { styled } from '@erecruit/ui-kit';

export const ScreenOverlay = styled.div<{}>(({ theme: { newColors } }) => ({
  position: 'fixed',
  width: '100%',
  height: '100%',
  background: newColors.bgModal,
  opacity: 0.7,
  //@TODO refactor hardcoded z-index using constants
  zIndex: 999,
}));
